<template>
  <b-container fluid class="mt-2 recruiter create-job-offer v2_color_black h-100">
    <b-row class="edit-box-container-row">
      <b-col cols="12" class="edit-box-container-col card v3_box_teal_body">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center align-items-center">
          <b class="v3_color_teal text-center v2_font_size_22 p-2"> Revise Your Job Opportunity</b>
        </b-col>
      </b-row>
      <b-row  v-if="this.is_first_time_on_edit">
        <b-col cols="12" class="d-flex justify-content-center align-items-center">
          <!-- <span class="v3_color_teal text-center" v-if="this.is_first_time_on_edit">You can adjust the terms of job opportunity any time during the 90-day term to attract more interested candidates.</span> -->
          <!-- <b class="v3_color_teal mt-4" v-else>Register Your Job Opportunity</b> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card border-variant="light" class="mt-2 v2_bg_white h-100">
            <div v-if="this.existMissingFields">
              <b-alert show variant="warning">
                Job Information fields are empty and should be filled with values.
              </b-alert>
            </div>
            <b-row>
              <b-col sm="12" md="4" lg="3" class="mb-5">
                <div class="border_1 h-100 w-100 p-3">
                  <v-wait :visible="loadingDetail" :for="$options.name">
                    <template slot="waiting">
                      <HalfCircleSpinner />
                      <div class="spinner-message my-3 text-center">
                        Loading data...
                      </div>
                    </template>
                    <v-wait :visible="loadingJobTerms" for="job-terms">
                      <template slot="waiting">
                        <HalfCircleSpinner />
                        <div class="spinner-message my-3 text-center">
                          Loading job terms...
                        </div>
                      </template>
                      <div class="text-center v2_font_size_22 v2_font_Montserrat">
                        Job Criteria
                      </div>
                      <div class="d-flex flex-column justify-content-stretch">
                        <template v-for="criteria in jobCriteria">
                          <b-button
                            v-if="criteria.talent_type=='SPECIALTY'"
                            :key="criteria.id"
                            variant="v2_white_primary_teal"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active:
                                  selectedJobQuestion &&
                                  selectedJobQuestion.id === criteria.id,
                              },
                            ]"
                            @click="selectedJobQuestion = criteria"
                            title="Cannot edit. Close ‘Connect’ and start over from Welcome or your dashboard (if logged in)."
                          >
                            <span>
                              <i
                                class="mdi mdi-18px mdi-lock"
                              />
                              {{ criteria.label }}
                            </span>
                          </b-button>
                        </template>
                        <template v-for="jobQuestion in jobQuestions">
                          <b-button
                            :key="jobQuestion.id"
                            variant="v3_teal_outline"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active:
                                  selectedJobQuestion &&
                                  selectedJobQuestion.id === jobQuestion.id,
                              },
                            ]"
                            @click="selectedJobQuestion = jobQuestion"
                          >
                          
                            <span v-if="jobQuestion.type === 'LOCATION'">
                              <i
                                class="mdi mdi-18px mdi-lock"
                              />
                              {{ jobQuestion.label }}
                            </span> 

                            <span v-else>
                              <i
                                v-if="showLockIcon(jobQuestion)"
                                class="mdi mdi-18px mdi-lock"
                              />
                              {{ jobQuestion.label }}
                            </span>

                          </b-button>
                        </template>
                        <template v-for="jobTerm in jobTerms">
                          <b-button
                            :key="jobTerm.id"
                            variant="v3_teal_outline"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active:
                                  selectedJobQuestion &&
                                  selectedJobQuestion.id === jobTerm.id,
                              },
                            ]"
                            @click="selectedJobQuestion = jobTerm"
                          >
                            {{ jobTerm.label }}
                          </b-button>
                        </template>
                        <template v-for="criteria in jobCriteria">
                          <b-button
                            v-if="criteria.talent_type=='JOB_INFORMATION'"
                            :key="criteria.id"
                            variant="v2_white_primary_teal"
                            :class="[
                              'mb-2',
                              {
                                active:
                                  selectedJobQuestion &&
                                  selectedJobQuestion.id === criteria.id,
                              },
                            ]"
                            @click="selectedJobQuestion = criteria"
                          >
                            <span>
                              <i
                                v-if="showLockIcon(criteria)"
                                class="mdi mdi-18px mdi-lock"
                              />
                              {{ criteria.label }}
                            </span>
                          </b-button>
                        </template>
                      </div>
                    </v-wait>
                  </v-wait>
                </div>
              </b-col>
              <b-col sm="12" md="8" lg="6" class="mb-5">
                <div class="border_1 h-100 w-100 p-3 mb-4">
                  <template v-if="selectedJobQuestion">
                    <b-row class="position-relative h-100">
                      <b-col>
                        <job-offer-input
                          v-if="selectedJobQuestion"
                          ref="jobOfferInput"
                          :job-question="selectedJobQuestion"
                          :job-offer="jobOffer"
                          :loading="loadingDetail"
                          @save-details="updateJobOfferDetails"
                          @save-specialty="updateSpecialty"
                          @set-criteria-value="onSetJobQuestionValue"
                          @clear-criteria-value="onClearCriteria"
                          @set-job-terms="onSetJobTerms"
                          @set-profile-job-terms="onSetProfileJobTerms"
                        />
                        <div class="d-flex align-items-center mt-4 w-100 justify-content-center"  v-if="isObjectNotEmpty(jobOffer)">
                          <b-button variant="primary" @click="goToOpportunity()" class="align-items-center margin-0-auto btn-next position-bottom width-fit-content">
                            Connect Your Revised Job Opportunity
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-else>
                    <b-row  class="position-relative h-100 mt-4">
                      <b-col>
                        <div
                          class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                        >
                          <span>
                            You can adjust the terms of your Job Opportunity any time during the 90-day term to attract more interested candidates.
                          </span><p/>
                          <span>
                            1. Select job term(s) you want to adjust from the “Job Criteria” menu. 
                            <p><b>Note: you may not adjust the Specialty/Subspecialty or Location of an Active job opportunity.</b></p>
                          </span>
                          <span>
                            2. If you are satisfied with the results of the adjusted job opportunity, click “Connect Your Opportunity”
                          </span><p/>
                          <span>
                            3. We will immediately alert matching candidates to your revised Job Opportunity.
                          </span><p/>
                        </div>
                        <div class="d-flex align-items-center mt-4 w-100 justify-content-center" v-if="isObjectNotEmpty(jobOffer)">
                          <b-button to="/recruiter" variant="primary" class="align-items-center margin-0-auto btn-next position-bottom width-fit-content">
                            Connect Your Revised Job Opportunity
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                    <!-- <b-row v-else>
                      <b-col>
                        Select the criteria from the left menu to adjust.
                      </b-col>
                    </b-row> -->
                  </template>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3" class="mt-md-2 mt-lg-0 mb-5">
                <div class="border_1 h-100 w-100 pt-1 pb-4 px-2">
                  <b-row>
                    <b-col sm="12" md="6" lg="12">
                      <job-offer-values
                        :job-questions="jobOfferCriteriaAndJobQuestions"
                        :job-offer="jobOffer"
                        :job-question="selectedJobQuestion"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="12" class="mt-3 mt-md-0 mt-lg-3">
                      <recruiter-job-offers-matching>
                        <template slot="number">
                          {{ numberOfMatches }}
                        </template>
                      </recruiter-job-offers-matching>
                      <!-- <div class="mt-3 text-center">
                        <b-button
                          variant="v2_primary"
                          @click="onSave"
                          :disabled="
                            postItLaterLoading ||
                            postItNowLoading ||
                            isCriteriaButtonDisabled
                          "
                        >
                          <b-spinner small v-if="postItLaterLoading" />
                          <span v-else>{{ saveButtonTitle }}</span>
                        </b-button>
                      </div> -->
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        :visible="createJobModalVisible"
        hide-footer
        size="lg"
        @hidden="createJobModalVisible = false"
      >
        <div slot="modal-title" class="v2_color_black v2_font_weight_semibold">
          Your job offer has been created
        </div>
        <p>
          You can post your job opportunity to the Connect exchange now or save it
          to post later from Connect or your Dashboard. Your paid term of posting
          starts on the date of posting.
        </p>
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            variant="v2_primary"
            @click="onPostJobOffer(1)"
            class="mr-4"
            :disabled="postItNowLoading || existMissingFields"
          >
            <b-spinner small v-if="postItNowLoading" />
            <span v-else>Post it now</span>
          </b-button>
          <b-button
            variant="v2_white"
            @click="onPostJobOffer(0)"
            :disabled="postItLaterLoading"
          >
            <b-spinner small v-if="postItLaterLoading" />
            <span v-else>Post it Later</span>
          </b-button>
        </div>
      </b-modal>
    </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RecruiterJobOffersMatching from '@/components/recruiter/job_offers/RecruiterJobOffersMatching';
import { createLocationCriteria } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import JobOfferInput from '@/components/recruiter/exchange/create-job-offer/job-offer-input/JobOfferInput';
import {
  JOB_OFFER_CRITERIA,
  JOB_TERMS,
  JOB_OTHER_CRITERIA
} from '@/helpers/recruiter/jobOfferHelper';
import JobOfferValues from '@/components/recruiter/exchange/create-job-offer/job-offer-values/JobOfferValues';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';
//import Help from '@/providers/Help';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';

// const modifiedConfirmMessage =
//   'The job offer has been modified but not saved yet. Would you like to continue and lose your changes?';

export default {
  name: 'CreateEditJobOffer',
  components: {
    RecruiterJobOffersMatching,
    JobOfferInput,
    JobOfferValues,
    HalfCircleSpinner,
  },
  data: function () {
    const filteredJobOtherCriteria = JOB_OTHER_CRITERIA.filter(criteria => {
      const updatedCriteria = { ...criteria }; 
      if (Array.isArray(updatedCriteria.jobQuestionVariables)) {    
        const indexToRemove = updatedCriteria.jobQuestionVariables.findIndex(item => item.id === "PNA" || item.id === "NA");
        if (indexToRemove !== -1) {
          updatedCriteria.jobQuestionVariables.splice(indexToRemove, 1);
        }
      }  
      return updatedCriteria;
    });
    return {
      test: filteredJobOtherCriteria,
      selectedJobQuestion: null,
      jobCriteria: JOB_OFFER_CRITERIA,
      jobTerms: [...filteredJobOtherCriteria,...JOB_TERMS],
      loadingDetail: false,
      loadingJobTerms: false,
      postItLaterLoading: false,
      postItNowLoading: false,
      existMissingFields: false,
      createJobModalVisible: false,
      jobOffer: {},
      isJobOfferDirty: false,
      jobQuestions: [],
      numberOfMatches: 0,
      jobId:this.$route.params.joId ? this.$route.params.joId : 0,
      is_first_time_on_edit:true
    };
  },
  created: async function () {
    await this.getJobQuestions();
    if (this.$route.params.joId) {
      await this.getJobOfferData();
    } else {
      this.jobOffer.job_terms = {};
    }
    // if(!this.is_first_time_on_edit)
    // {
    //   console.log(this.jobCriteria[0], "this.jobCriteria[0]");
    //   this.selectedJobQuestion = this.jobCriteria[0];
    // }
  },
  beforeMount: function () {
    window.addEventListener('beforeunload', this.preventEventIfDirtyOrErrors);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener(
        'beforeunload',
        this.preventEventIfDirtyOrErrors
      );
    });
    this.$root.$on('job-information-filled', (isJobInformationFilled) => {
      this.existMissingFields = !isJobInformationFilled;
      this.showSaveModal();
    });
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.postItLaterLoading || this.postItNowLoading) {
      return next(false);
    }
    return next();
    // return this.isDirty()
    //   ? Help.confirm.show(
    //       modifiedConfirmMessage,
    //       'Leave',
    //       () => {
    //         next();
    //       },
    //       () => {
    //         next(false);
    //       }
    //     )
    //   : next();
  },
  computed: {
    saveButtonTitle: function () {
      return this.jobOffer.id ? 'Save Job Offer' : 'Create Job Offer';
    },
    isGmAdmin: function () {
      return this.$store.getters.userIsGMAdmin;
    },
    isMssRecruiter: function () {
      return this.$store.getters.userIsMSSRecruiter;
    },
    isCriteriaButtonDisabled: function () {
      return true;
      // return (
      //     (this.jobOffer || {}).status === JOB_OFFER_STATUSES.ACTIVE &&
      //     !this.isGmAdmin
      // );
    },
    jobOfferCriteriaAndJobQuestions: function () {
      return [...this.jobCriteria, ...this.jobQuestions, ...this.jobTerms];
    },
  },
  methods: {
    onSetCriteriaValue: function (params) {
      const index = this.jobCriteria.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobCriteria[index], 'value', params);
    },
    onClearCriteria: function () {
      const index = this.jobTerms.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobTerms[index], 'value',null);
      this.$delete(this.jobOffer.job_terms, this.jobTerms[index].type);
      this.updateJobOffer();
    },
    updateJobOfferDetails: function (data) {
      const {
        title,
        description,
        tracking,
        jobBoardUrl,
        company,
        zipCode,
        welcome_message,
        practice_name
      } = data;
      this.$set(this.jobOffer, 'title', title);
      this.$set(this.jobOffer, 'description', description);
      this.$set(this.jobOffer, 'tracking_num', tracking);
      this.$set(this.jobOffer, 'external_url', jobBoardUrl);
      this.$set(this.jobOffer, 'company_name', company);
      this.$set(this.jobOffer, 'location_zip_code', zipCode);
      this.$set(this.jobOffer, 'welcome_message', welcome_message);
      this.$set(this.jobOffer, 'practice_name', practice_name);
      this.isJobOfferDirty = true;
      this.updateJobOffer();
    },
    updateSpecialty: function (data) {
      const { specialtyId, subspecialtyId } = data;
      this.$set(this.jobOffer, 'specialty_id', specialtyId);
      this.$set(this.jobOffer, 'subspecialty_id', subspecialtyId);
      this.isJobOfferDirty = true;
      this.updateJobOffer();
    },
    getJobOfferData: async function () {
      this.loadingDetail = true;
      try {
        this.jobOffer = await Api.getJobOfferData(this.$route.params.joId);
        if(this.jobOffer)
        {
          if(this.jobOffer.is_edit==0) {
            this.is_first_time_on_edit = true;
            await this.checkFirstOnEditPage(this.$route.params.joId);
          }else{
            this.is_first_time_on_edit = false;
          }
        }
        if (
          this.jobOffer.job_terms === null ||
          Array.isArray(this.jobOffer.job_terms)
        ) {
          this.$set(this.jobOffer, 'job_terms', {});
        }
        if (
          this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        ) {
          this.setResponsesFromCookies();
        } else {
          this.setJobQuestionResponses();
          this.setJobTermsResponses();
        }
        this.getNumberOfMatches();
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          this.$toasted.error('You are not allowed to view this job offer', {
            duration: 3000,
          });
          this.$router.push('/recruiter/exchange');
        } else handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingDetail = false;
      }
    },
    setJobQuestionResponses: function () {
      if (!this.jobQuestions || !this.jobOffer.jobQuestionResponses) return;
      Object.entries(this.jobOffer.jobQuestionResponses).forEach(
        ([id, value]) => {
          const index = this.jobQuestions.findIndex(
            (jq) => jq.id === parseInt(id)
          );
          if (index === -1) return;
          this.$set(this.jobQuestions[index], 'value', value);
        }
      );
      if(this.jobOffer.location_zip_code)
      {
        const locIndex = this.jobQuestions.findIndex(item => item.talent_type === 'LOCATION');
        this.jobQuestions[locIndex].value = this.jobOffer.location_zip_code;
        this.jobQuestions[locIndex].jobQuestionVariables = [];
      }
    },
    setJobTermsResponses: function () {
      if (!this.jobTerms || !this.jobOffer.job_terms) return;
      Object.entries(this.jobOffer.job_terms).forEach(([type, value]) => {
        const index = this.jobTerms.findIndex((jt) => jt.type === type);
        if (index === -1) return;        
        if (Array.isArray(value) && index == 1) {          
          this.$set(this.jobTerms[index], 'value', value);
        }else{
          this.$set(this.jobTerms[index], 'value', []);
          this.$set(this.jobTerms[index].value, 0, value);        
        }
      });
    },
    setResponsesFromCookies: function () {
      const values = JSON.parse(
        this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
      );
      values.forEach(({ id, type, value }) => {
        if (!value) return;

        if (type === JOB_QUESTION_TYPES.SPECIALTY) {
          const index = this.jobCriteria.findIndex(
            (i) => i.type === JOB_QUESTION_TYPES.SPECIALTY
          );
          if (index === -1) return;
          this.$set(this.jobCriteria[index], 'value', { ...value });
          this.$set(this.jobOffer, 'specialty_id', value.specialtyId);
          this.$set(this.jobOffer, 'subspecialty_id', value.subspecialtyId);
          return;
        }

        if (type === JOB_QUESTION_TYPES.LOCATION) {
          const index = this.jobCriteria.findIndex(
            (i) => i.type === JOB_QUESTION_TYPES.JOB_INFORMATION
          );
          if (index === -1) return;
          this.$set(this.jobCriteria[index], 'value', { ...value });
          this.$set(
            this.jobOffer,
            'location_zip_code',
            value.location_zip_code
          );
          return;
        }

        const index = this.jobQuestions.findIndex((jQ) => {
          return jQ.id === id;
        });
        if (index === -1) return;
        this.$set(this.jobQuestions[index], 'value', { ...value });
      });
    },
    onPostJobOffer: async function (postItNow = 0) {
      if (this.jobOffer.id) {
        await this.saveJobOffer(postItNow);
      } else {
        await this.createJobOffer(postItNow);
      }
      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        this.$cookies.remove(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES);
      }
    },
    createJobOffer: async function (postItNow = 0) {
      const loadingVarName = postItNow
        ? 'postItNowLoading'
        : 'postItLaterLoading';
      this[loadingVarName] = true;
      try {
        const jobOffer = {
          ...this.jobOffer,
          jobQuestions: this.jobQuestions,
        };

        await Api.createJobOfferData(jobOffer, postItNow);
        this.resetValidation();
        this[loadingVarName] = false;
        this.$router.push('/recruiter/exchange');
        this.$toasted.success('Job Offer created successfully', {
          duration: 3000,
        });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this[loadingVarName] = false;
        this.createJobModalVisible = false;
      }
    },
    saveJobOffer: async function (postItNow = 0) {
      const loadingVarName = postItNow
        ? 'postItNowLoading'
        : 'postItLaterLoading';
      this[loadingVarName] = true;

      try {
        await this.updateJobOffer(postItNow);
        this.resetValidation();
        this[loadingVarName] = false;
        this.$toasted.success('Job Offer updated successfully', {
          duration: 3000,
        });
        if (this.isGmAdmin) {
          this.$router.push('/admin/job-offers');
        } else {
          this.$router.push('/recruiter/exchange');
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this[loadingVarName] = false;
        this.createJobModalVisible = false;
      }
    },
    updateJobOffer: async function () {
      // const locIndex = this.jobQuestions.findIndex(item => item.talent_type === 'LOCATION');
      // this.jobOffer.location_zip_code  = this.jobQuestions[locIndex].value.location_zip_code;

      const jobOffer = {
        ...this.jobOffer,
        jobQuestions: this.jobQuestions,
      };
      try {
        if (this.isGmAdmin) {
          await Api.updateJobOfferDataByGmAdmin(jobOffer);
        } else {
          this.$store.state.edit_job_offer = jobOffer;
          //await Api.updateJobOfferData(jobOffer, postItNow);
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        await this.getICONumberOfMatches(jobOffer);
      }
    },
    getICONumberOfMatches: async function (jobOffer) {
      //console.log(JSON.stringify(jobOffer.jobQuestions));
      //this.numberOfMatches = await Api.getProfileNumberOfMatches(jobOffer);
      this.numberOfMatches = await Api.findNumberOfMatches(jobOffer,1);
    },
    getNumberOfMatches: async function () {
      this.numberOfMatches = await Api.getNumberOfJobOfferMatches(
        this.jobOffer.id
      );
    },
    onSave: function () {
      if (this.isGmAdmin) return this.saveJobOffer();
      this.$root.$emit('check-job-information-filled');
    },
    showSaveModal: function () {
      this.createJobModalVisible = true;
    },
    isDirty: function () {
      return (
        this.isJobOfferDirty ||
        (this.$refs.jobOfferInput &&
          typeof this.$refs.jobOfferInput.isDirty === 'function' &&
          this.$refs.jobOfferInput.isDirty())
      );
    },
    hasErrors: function () {
      return this.$refs.jobOfferInput &&
        typeof this.$refs.jobOfferInput.hasErrors === 'function'
        ? this.$refs.jobOfferInput.hasErrors()
        : false;
    },
    resetValidation: function () {
      this.isJobOfferDirty = false;
      return (
        this.$refs.jobOfferInput &&
        typeof this.$refs.jobOfferInput.resetValidation === 'function' &&
        this.$refs.jobOfferInput.resetValidation()
      );
    },
    preventEventIfDirtyOrErrors: function (event) {
      if (!this.postItLaterLoading && !this.isDirty() && !this.hasErrors())
        return;
      event.preventDefault();
      event.returnValue = '';
    },
    getJobQuestions: async function () {
      const additionalCriteria = createLocationCriteria();
      this.loadingJobTerms = true;
      try {
        this.jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
        this.jobQuestions = [additionalCriteria, ...this.jobQuestions];
        this.setJobQuestionResponses();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingJobTerms = false;
      }
    },
    checkFirstOnEditPage: async function() {
      try {
        await Api.updateEditFlag(this.$route.params.joId);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingJobTerms = false;
      }
    },
    onSetJobQuestionValue: function (params) {
      const index = this.jobQuestions.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobQuestions[index], 'value', {
        ...params,
      });
      this.updateJobOffer();
    },
    onSetJobTerms: function (params) {
      const index = this.jobTerms.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.jobTerms[index], 'value', {
        ...params,
      });
      this.$set(
        this.jobOffer.job_terms,
        this.jobTerms[index].type,
        { ...params }[0]
      );
      this.updateJobOffer();
    },
    onSetProfileJobTerms: function (params) {
      const index = this.jobTerms.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      if (!params || !Object.keys(params).length) {       
        this.$delete(this.jobTerms[index], 'value');
        this.$delete(this.jobOffer.job_terms, this.jobTerms[index].type);
        return;
      }   
      if(JOB_QUESTION_TYPES.ETHNICITY && index == 1){        
        this.$set( this.jobTerms[index], 'value', params ? params : {} );
        
        this.$set( this.jobOffer.job_terms, this.jobTerms[index].type, params || null );        
      }else{        
        let key = Object.keys(params)[0];

        this.$set(this.jobTerms[index],'value', key ? { 0: key,} : {});

        this.$set(this.jobOffer.job_terms, this.jobTerms[index].type, key || null);
      }

      this.updateJobOffer();
    },
    showLockIcon: function (criteria) {
      return (
        !!(
          this.jobOffer &&
          this.jobOffer.is_payment_success &&
          this.jobOffer.specialty_id
        ) && criteria.type === JOB_QUESTION_TYPES.SPECIALTY
      );
    },
    isObjectNotEmpty(obj) {
      return Object.keys(obj).length > 0;
    },
    goToOpportunity: async function(){
      try {
        if(this.$store.state.edit_job_offer)
        {
          //// If user update any criterias and try to connect opportunity //////
          if(await Api.updateJobOfferData(this.$store.state.edit_job_offer, 0))
          {
            this.$toasted.success('Job Offer saved successfully', {
              duration: 3000,
            });
            this.$store.state.edit_job_offer = undefined;
          }
        }else{
          //// If user without update any criterias and try to connect opportunity //////
          const jobOffer = {
            ...this.jobOffer,
            jobQuestions: this.jobQuestions,
          };
          try {
            if (this.isGmAdmin) {
              await Api.updateJobOfferDataByGmAdmin(jobOffer);
            } else {
              await Api.updateJobOfferData(jobOffer, 0)
            }
          } catch (error) {
            handleServerErrorWithValidation(error, this.$toasted);
          } finally {
            await this.getICONumberOfMatches(jobOffer);
          }
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } 
      this.$router.push('/recruiter');
    }
  },
};
</script>

<style scoped>
.margin-0-auto{
  margin: 0 auto;
}
.btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  opacity: 1;
}
.position-bottom{
  position:absolute;bottom: 20px;
}
.justify-content-center{
  justify-content:center;
}
.position-relative{
  position: relative;
}
.position-relative i{
  position: absolute;
  right: 10px;
}
.edit-box-container-col {
	margin: 0 auto;
	padding: 10px;
	display: inline-block;
	max-width: 2000px;
}
.edit-box-container-row {
	padding: 0px 10px;
  background-color: rgba(2,22,35,0.025);
}
.width-fit-content{
  width:fit-content;
}
@media (max-width:768px){
  .position-bottom{
    position:unset !important;
  }
  .btn-next{
    max-height: unset !important;
  }
}
</style>
